<template>
  <div id="problemOrder">
    <div class="yto-box search-form" style="padding-bottom:0">
      <el-form
        ref="searchForm"
        :inline="true"
        :model="form"
        label-width="75px"
      >
      <el-row>
        <el-form-item prop="createTime" label="生成时间" class="time-style">
          <yto-date-picker
            :maxRangeVal="31"
            :picker-options="pickerOptions1"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form.createTime"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
            :editable="false"
          ></yto-date-picker>
        </el-form-item>
        <el-form-item prop="problemCode" label="问题类型">
          <el-select v-model="form.problemCode" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item,index) in problemList"
              :key="item.problemCode + index"
              :label="item.problemName"
              :value="item.problemCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="form.customerStateId" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="未回复" value="tobe"></el-option>
            <el-option label="已回复" value="done"></el-option>
            <el-option label="网点已处理" value="wdgj_done"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户编码" prop="customerCode">
          <el-select v-model="form.customerCode" filterable placeholder="请选择" clearable @change="handleSelect" @clear='clearCustomerCode'>
            <el-option
              v-for="item in restaurants"
              :key="item.code"
              :label="item.code+'-'+item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称" prop="sellerId">
          <el-select v-model="form.sellerId" filterable placeholder="请选择" clearable>
            <el-option
              v-for="item in shopList"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号" prop="waybillNo" class="textarea-style">
            <el-input
            type="textarea"
            :rows="4"
            resize="none"
            placeholder="请输入单号，最多200个，请用，或者换行隔开"
            v-model="form.waybillNo"
            ></el-input>
        </el-form-item>
        <el-form-item  style="float:right; margin-right:0">
          <div class="button-group">
            <el-button type="primary" @click="pageChange(1)" icon="el-icon-search">查询</el-button>
            <el-button class="normal-btn" @click="resetForm('searchForm')"><i class="el-icon-refresh-left y-fc-4C84FF"></i>重置</el-button>
            <el-button @click="exportFile" plain :disabled="total === 0 || exportLoading">导出</el-button>
          </div>
        </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div class="yto-box">
      <div class="mb20">
        <el-button type="primary" id="copy_text" class="mr20 copyBtn" :data-clipboard-text="copyTxt" @click="copyWaybillNo"><i class="el-icon-document-copy y-mr-5"></i>复制单号</el-button>
        <el-tooltip effect="light" placement="bottom-start">
          <span slot="content">
            <span style="color:#330000">待办须知</span><br />
            <span style="color:#666666">合作网点推送给您需要确认的快件问题，请及时回复您的处理意见，以便网点尽快为您转出快件</span><br />
            <span style="color:#666666">未回复：需要您回复的快件问题</span><br />
            <span style="color:#666666">已回复：您已回复的快件问题（组织内任何成员回复都可见）</span><br />
            <span style="color:#666666">网点已处理：网点客服已代您处理，无需回复</span>
          </span>
          <span class="helpInfo"><i class="el-icon-warning systemColor helpIcon mr5" style="cursor: pointer"></i>待办须知</span>
        </el-tooltip>
      </div>
      <div class="yto-table">
        <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" v-loading='tableLoading'>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="waybillNo" label="运单号"  min-width="130">
            <template slot-scope="scope">
              <span class="hilightColor" @click="showWaybillDetail(scope.row)">{{scope.row.waybillNo}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="kcode" label="客户编码">
            <template slot-scope="scope">
              <span v-if="scope.row.kcode">{{scope.row.kcode}}</span>
              <span v-if="scope.row.kcode && scope.row.kname"> - </span>
              <span v-if="scope.row.kname">{{scope.row.kname}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sellerName" label="店铺名称"></el-table-column>
          <el-table-column prop="problemName" label="问题类型"></el-table-column>
          <el-table-column min-width="200px" label="问题内容" class="desc-form">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" width="400">
                <p style="font-size:12px" class="hover-popover"> 
                  <span v-if="scope.row.problemType == 'issue'">{{scope.row.problemDesc}}</span>
                  <span v-if="scope.row.problemType == 'complaint_problem' || scope.row.problemType == 'urge_problem'">{{scope.row.problemContent}}</span>
                </p>
                <div slot="reference" style="line-height: 22px;max-height: 66px;overflow: hidden;text-overflow: ellipsis; white-break:wrap">
                  <span class="overflowHiding" v-if="scope.row.problemType == 'issue'">{{scope.row.problemDesc}}</span>
                  <span class="overflowHiding" v-if="scope.row.problemType == 'complaint_problem' || scope.row.problemType == 'urge_problem'">{{scope.row.problemContent}}</span>
                  <!-- problemType="issue"问题件取problemDesc；problemType="complaint_problem"投诉取problemContent -->
                  <!-- urge_problem取problemContent -->
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="problemCreateTime" label="生成时间" min-width="150"></el-table-column>
          <el-table-column prop="customerStateId" label="处理状态">
            <template slot-scope="scope">
              <span v-if="scope.row.customerStateId === 'tobe'">未回复</span>
              <span v-if="scope.row.customerStateId === 'done'">已回复</span>
              <span v-if="scope.row.customerStateId === 'wdgj_done'">网点已处理</span>
            </template>
          </el-table-column>
          <el-table-column prop="replyContent" min-width="200px" label="处理内容"  class="desc-form">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" width="400">
                <p style="font-size:12px" class="hover-popover">{{ scope.row.replyContent }}</p>
                <div slot="reference" style="line-height: 22px;max-height: 66px;overflow: hidden;text-overflow: ellipsis; white-break:wrap">
                  <span class="overflowHiding">{{scope.row.replyContent}}</span>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="customerProcessTime" label="处理时间"></el-table-column>
          <el-table-column label="操作" width="80px" >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleOrder(scope.row)" v-if="scope.row.customerStateId === 'tobe'">回复</el-button>
              <el-button type="text" size="small" @click="handleOrder(scope.row)" v-else>查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="limitChange"
          @current-change="pageChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 50]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 走件详情 -->
    <orderTrackingDetails
      :value="showDialog"
      v-if="showDialog"
      :fromPage="'problemOrder'"
      :data="orderDetailsData"
      @close="closeDetailInfo"
      ref="orderTrackingDetails"
    ></orderTrackingDetails>
    <handleProblemOrder
      :value="handleProblemDialog"
      v-if="handleProblemDialog"
      :waybillNo="handleProbleData.waybillNo"
      :problemType="handleProbleData.problemType"
      :id="handleProbleData.id"
      @close="closehandleProblem"
      ref="handleProblemOrder"
    ></handleProblemOrder>
    <el-dialog :visible.sync="dialogVisible" :title="(dialogUrlType=='image')?'图片':'视频'" @close='closeImg' class="imgDialog">
      <div v-if="dialogVisible">
        <img style="width:auto;max-width:100%;max-height:550px;display:block; margin:0 auto" :src="dialogImageUrl" alt="" v-if="dialogUrlType=='image'">
        <video controls="" name="media" style="width:100%;height:550px;display:block; margin:0 auto;" v-else>
          <source :src="dialogImageUrl" type="video/mp4">
        </video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import netAPI from '@/api';
import { YTOSHORTCUTSNo, dateFormat, downloadFile } from '@/utils/util';
import orderTrackingDetails from './components/orderTrackingDetails'; // 走件物流轨迹
import handleProblemOrder from '@/components/handleProblemOrder/index'; // 走件物流轨迹
export default {
  components: {
    orderTrackingDetails,
    handleProblemOrder,
  },
  name: 'problemOrder',
  mixins: [],
  data() {
    return {
      multipleSelection: [],
      copyTxt: '',
      restaurants: [],
      pickerOptions1: {
        ...YTOSHORTCUTSNo,
        disabledDate(time) {
          let start = new Date(new Date().getTime() - 59 * 24 * 3600000);
          return (
            time.getTime() > new Date((`${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`).split('-').join('/')).getTime() ||
            time.getTime() < new Date((`${dateFormat(start, 'yyyy-MM-dd')} 00:00:00`).split('-').join('/')).getTime()
          );
        }
      },
      form: {
        createTime: [],
        problemCode: '',
        customerStateId:'tobe',
        waybillNo: '',
        customerCode: '',
        sellerId: ''
      },
      waybillNoList:[],
      shopList: [],
      problemList: [],
      showSmall: true,
      tableData: [],
      pageNo: 1,
      limit: 10,
      total: 0,
      exportLoading: false,
      showDialog: false, // 走件物流轨迹
      orderDetailsData: {},
      handleProblemDialog: false, // 处理问题件
      handleProblemData: {},
      tableLoading: false,
      dialogImageUrl: '',
      dialogUrlType: 'image',
      dialogVisible: false
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  beforeCreate() {},
  created() {
    this.getKCode();
    this.chengeTimeType('今日');
  },
  mounted() {
    if(this.$route.query.waybillNos){
      this.form.waybillNo = this.$route.query.waybillNos.replace(/\%/g, ",") || '';
    }
    if(localStorage.getItem('waybillNo')){
      this.form.waybillNo = localStorage.getItem('waybillNo') || '';
      localStorage.removeItem('waybillNo');
    }
    if (this.$route.params.fromPage == 'gpt' && this.$route.params.startDate) {
      let startDate = this.$route.params.startDate;
      let endDate = this.$route.params.endDate;
      let createTime = [
        `${dateFormat(new Date(startDate), 'yyyy-MM-dd')} 00:00:00`,
        `${dateFormat(new Date(endDate), 'yyyy-MM-dd')} 23:59:59`
      ];
      this.$set(this.form, 'createTime', createTime);
    }
    this.queryIssueType();
    this.pageNo = 1;
    
    // 从gpt跳转过来的
    this.bus.$off('addParams_problemOrder').$on('addParams_problemOrder', (params) => {
      if (params.fromPage == 'gpt' && params.startDate) {
        let startDate = params.startDate;
        let endDate = params.endDate;
        let createTime = [
          `${dateFormat(new Date(startDate), 'yyyy-MM-dd')} 00:00:00`,
          `${dateFormat(new Date(endDate), 'yyyy-MM-dd')} 23:59:59`
        ];
        this.$set(this.form, 'createTime', createTime);
        this.$nextTick(()=>{
          this.queryIssueType();
          this.pageNo = 1;
        })
      }
    });
  },
  methods: {
    // 导出
    exportFile() {
      this.waybillNoList = [];
      let arr =  this.form.waybillNo?this.form.waybillNo.split(/[(\r\n)\r\n]+/):[];
      let arr1 = [];
      arr.forEach(function (r) {
        arr1.push(r.split(','));
      });
      arr1 = [].concat(...arr1);
      arr.length = 0;
      arr1.forEach(function (t) {
        arr.push(t.split('，'));
      });
      arr = [].concat(...arr);
      arr = arr.filter(Boolean);//去掉数组中空值
      if (arr && arr.length > 200) {
        this.$message.error('最多只能输入200个运单号！');
        return false;
      }
      this.waybillNoList = arr.filter((item) =>{
        return item && item.trim()
      });
      let falseFlag2 = false;
      let lengthFlag2 = false;
      this.waybillNoList.forEach((r) => {
        if (r) {
          r = r.replace(/\s+/g, '');// 去所有空格
          let reg = /^[A-Za-z0-9]+$/; // 匹配由数字和26个英文字母组成的字符串
          if (!reg.test(r)) {
            falseFlag2 = true;
          }
          if (r.length > 20) {
            lengthFlag2 = true;
          }
        }
      });
      if (falseFlag2) {
        this.$message.error('运单号只能输入字母及数字');
        return false;
      }
      if (lengthFlag2) {
        this.$message.error('运单号不得超过20位');
        return false;
      }
      if (this.pageNo * this.limit > 200000) {
        this.$message.warning('提示：数据量过大，请优先处理前几页数据');
        return false;
      }
      let params = {
        waybillList: this.waybillNoList,
        customerStateId:this.form.customerStateId,
        startDate: this.form.createTime[0],
        endDate: this.form.createTime[1],
        groupId: this.userMess.groupId,
        userId: this.userMess.loginId,
        problemCode: this.form.problemCode,
        limit: this.limit,
        pageNo: this.pageNo,
        customerCode: this.form.customerCode,
      };
      if (params.customerCode) {
        params.sellerId = this.form.sellerId || '';
      }
      this.exportLoading = true;
      if (this.total === 0) {
        this.$message.error('当前无数据可导出!');
      // } else if (this.total > 30000) {
      //   this.$message.error('一次性导出数据不能超过30000条!');
        this.exportLoading = false;
      } else {
        netAPI
          .exportIssueList(params)
          .then(res => {
            this.exportLoading = false;
            let blob = new Blob([res], { type: 'application/x-xls' });
            let fileName = '客户管家收到的工单列表导出.xls';
            downloadFile(blob, fileName);
          }).catch(()=>{
            this.exportLoading = false;
          });
      }
    },
    rTime(date) {
      let dateJson = new Date(date).toJSON();
      return new Date(new Date(dateJson) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
    },
    closeImg() {
      this.dialogImageUrl = '';
    },
    getKCode() {
      let params = {
        groupId: this.userMess.groupId,
        loginId: this.userMess.loginId
      };
      this.restaurants = [];
      netAPI.getKCode(params).then(res => {
        if (res.success && res.data && res.data.length) {
          this.restaurants = res.data || [];
          let defaultKcode = this.$route.params.customerCode;
          let defaultList = res.data.filter(m => { return m.code == defaultKcode; });
          if (defaultList.length) {
            this.form.customerCode = defaultList[0].code;
            this.handleSelect(this.form.customerCode);
          }
        } else {
          this.restaurants = [];
        }
      }).catch((err) => {
        this.restaurants = [];
        console.log(err);
      }).finally(()=>{
        // 从异常监控页面跳过来时，如果带了k， 但没有带店铺信息时，k列表取完再查一次列表
        if (!this.$route.params.shopCode) {
          this.queryIssueList();
        }
      });
    },
    // 查询条件——获取店铺名称列表
    handleSelect(item) {
      if (!item) {
        return false;
      }
      let params = {
        k_Code: item,
        userCode: item
      };
      this.shopList = [];
      this.form.sellerId = '';
      netAPI.getListShop(params).then(res => {
        if (res.success) {
          this.shopList = res.data.shopInfoList || [];
          let defaultShopCode = this.$route.params.shopCode;
          let defaultList = this.shopList.filter(m => { return m.shopId == defaultShopCode; });
          if (defaultList.length) {
            this.form.sellerId = defaultList[0].shopId;
          }
        } else {
          this.shopList = [];
        }
      }).catch(() => {
        this.shopList = [];
      }).finally(()=>{
        // 从异常监控页面跳过来时，如果带了店铺信息，店铺列表取完再查一次列表
        if (this.$route.params.shopCode) {
          this.queryIssueList(1);
        }
      });
    },
    clearCustomerCode() {
      this.form.customerCode = '';
      this.shopList = [];
      this.form.sellerId = '';
    },
    chengeTimeType(){
      let createTime = [];
      // 从异常运单监控进页面时，时间默认为T-1
      if (this.$route.params.yesterday == 'T-1')  {
        let yesterday = new Date(new Date().getTime() - 1 * 24 * 3600000);
        createTime = [
          `${dateFormat(yesterday, 'yyyy-MM-dd')} 00:00:00`,
          `${dateFormat(yesterday, 'yyyy-MM-dd')} 23:59:59`
        ];
      } else {
        let yesterday = new Date(new Date().getTime() - 2 * 24 * 3600000);
        createTime = [
          `${dateFormat(yesterday, 'yyyy-MM-dd')} 00:00:00`,
          `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
        ];
      }
      this.$set(this.form, 'createTime', createTime);
    },
    // 复制单号-选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 复制单号到文本
    copyWaybillNo() {
      var newList = '';
      if (!(this.multipleSelection && this.multipleSelection.length)) {
        this.$message({message: '请勾选需复制的问题件单号', type: 'error'});
        return false;
      }
      this.multipleSelection.forEach(element => {
        newList += element.waybillNo + '\n';
      });
      // this.copyTxt = newList;
      // eslint-disable-next-line new-cap
      let clipboard = new this.clipboard('#copy_text', {
        text: () => {
          return newList;
        }
      });
      clipboard.on('success', e => {
        this.copyTxt = e.text;
        clipboard.destroy(); // 释放内存
        this.$message({message: '复制成功', type: 'success'});
      });
      clipboard.on('error', e => {
        clipboard.destroy(); // 释放内存
        // 不支持复制
        this.$message({message: '该浏览器不支持自动复制', type: 'fail'});
      });
    },
    // 显示运单号走件物流轨迹窗口
    showWaybillDetail(row) {
      this.showDialog = true;
      this.orderDetailsData = {
        code: row.waybillNo, // 订单号
        title: '运单详情', // dialog头部标题
        isComplaint: false, // 是否为客户投诉模块
        notShowStartOrder: true, // 是否不展示一键工单按钮
        kcode: row.kcode,
        kname: row.kname,
        sellerName: row.sellerName
      };
    },
    // 关闭运单号走件物流轨迹窗口
    closeDetailInfo() {
      this.showDialog = false;
    },
    // 关闭处理问题件窗口
    closehandleProblem() {
      this.handleProblemDialog = false;
      this.pageNo = 1;
      this.queryIssueList();
    },
    // 打开处理问题件窗口
    handleOrder(row) {
      this.handleProblemDialog = true;
      this.handleProbleData = row;
    },
    // handleClick(tab, event) {
    //   this.pageNo = 1;
    //   this.queryIssueList();
    // },
    // 每页条数改变
    limitChange(val) {
      this.limit = val;
      this.pageNo = 1;
      this.queryIssueList();
    },
    // 页码改变
    pageChange(val) {
      this.pageNo = val;
      this.queryIssueList();
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.shopList = [];
      this.form.problemCode = '';
      this.form.customerStateId = 'tobe';
      this.$nextTick(()=>{
        this.pageChange(1);
      })
    },
    // 获取问题件大类
    queryIssueType() {
      netAPI.queryIssueType().then(res => {
        if (res.status == 0 && res.data) {
          this.problemList = res.data || [];
        } else {
          this.problemList = [];
        }
      }).catch(() => {
        this.problemList = [];
      });
    },
    // 获取问题件列表
    queryIssueList() {
      this.waybillNoList = [];
      let arr =  this.form.waybillNo?this.form.waybillNo.split(/[(\r\n)\r\n]+/):[];
      let arr1 = [];
      arr.forEach(function (r) {
        arr1.push(r.split(','));
      });
      arr1 = [].concat(...arr1);
      arr.length = 0;
      arr1.forEach(function (t) {
        arr.push(t.split('，'));
      });
      arr = [].concat(...arr);
      arr = arr.filter(Boolean);//去掉数组中空值
      if (arr && arr.length > 200) {
        this.$message.error('最多只能输入200个运单号！');
        return false;
      }
      this.waybillNoList = arr.filter((item) =>{
        return item && item.trim()
      });
      let falseFlag2 = false;
      let lengthFlag2 = false;
      this.waybillNoList.forEach((r) => {
        if (r) {
          r = r.replace(/\s+/g, '');// 去所有空格
          let reg = /^[A-Za-z0-9]+$/; // 匹配由数字和26个英文字母组成的字符串
          if (!reg.test(r)) {
            falseFlag2 = true;
          }
          if (r.length > 20) {
            lengthFlag2 = true;
          }
        }
      });
      if (falseFlag2) {
        this.$message.error('运单号只能输入字母及数字');
        return false;
      }
      if (lengthFlag2) {
        this.$message.error('运单号不得超过20位');
        return false;
      }
      if (this.pageNo * this.limit > 200000) {
        this.$message.warning('提示：数据量过大，请优先处理前几页数据');
        return false;
      }
      let params = {
        waybillList: this.waybillNoList,
        customerStateId:this.form.customerStateId,
        startDate: this.form.createTime[0],
        endDate: this.form.createTime[1],
        groupId: this.userMess.groupId,
        userId: this.userMess.loginId,
        problemCode: this.form.problemCode,
        limit: this.limit,
        pageNo: this.pageNo,
        customerCode: this.form.customerCode,
      };
      if (params.customerCode) {
        params.sellerId = this.form.sellerId || '';
      }
      this.tableLoading = true;
      this.tableData = [];
      netAPI.queryIssueList(params).then(res => {
        console.log(res);
        if (res.data && res.status === 0) {
          this.tableData = res.data.items || [];
          this.total = res.data.total || 0;
          // if (this.tableData && this.tableData.length) {
          //   this.tableData.forEach(r => {
          //     r.createTime = this.rTime(r.createTime);
          //     console.log(r.createTime);
          //   });
          //   this.tableData = [...this.tableData];
          // }
        } else {
          this.$message.error(res.message || '查询失败');
          this.tableData = [];
          this.total = 0;
        }
        this.tableLoading = false;
      }).catch(() => {
        this.$message.error('查询失败');
        this.tableLoading = false;
        this.tableData = [];
        this.total = 0;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to pageNo CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../styles/variables';
.hilightColor {
  color: $blue-style;
  cursor: pointer;
}
#problemOrder {
  /deep/ .el-form-item__label{
    padding-right: 5px;
  }
  .time-style {
    /deep/ .el-form-item__content {
      width: 450px;
      display: inline-flex;
      justify-content: space-between;
    }
  }
  .textarea-style{
     /deep/ .el-form-item__content {
      width: 450px;
    }
  }
  .mr5 {
    margin-right: 5px;
  }
  .mr20 {
    margin-right: 20px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .copyBtn span{
      display: inline-flex!important;
      align-items: center;
      img{
        width: 14px;
        vertical-align: text-bottom;
        margin-right: 4px;
      }
  }
  .el-icon-document-copy {
    color: $white!important;
    font-size: 12px!important;
  }
  .helpIcon{
    &::before{
      font-size: 14px;
    }
  }
  .helpInfo{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }
}
.overflowHiding{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
	text-overflow: ellipsis;
}
.search-form .el-button--small {
  width: 80px;
}
.hover-popover{
  max-width: 600px;
  max-height: 400px;
  overflow-y: auto;
}
.imgDialog{
  /deep/ .el-dialog__body div{
    max-height: 600px;
    overflow-y: auto;
  }
}
.elli {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
